import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { LOCALSTORAGEKEYS } from '../_constants/localStorageKeys';
import {
    PERMANENT_HARD_REFRESH_EXCLUDED,
    PERMANENT_HARD_REFRESH_REQUIRED,
} from '../_constants/permanentHardRefreshRequired';
import { CommonService } from '../_services/_common/common.service';
import { LocalService } from '../_services/_storage/local.service';
import { UserService } from '../_services/_user/user.service';
import { SnackbarService } from '../_services/snackbar/snackbar.service';
import { SERVICE_URL } from '../_urls/service.urls';

@Injectable()
export class HttpHeaderConfigInterceptor implements HttpInterceptor {
    static locationId: any = '';
    forceCacheUpdate = false;

    constructor(
        private localService: LocalService,
        private snackbarService: SnackbarService,
        private userService: UserService,
        private commonService: CommonService
    ) {}

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        this.commonService.isTableRefresh.subscribe((value) => {
            if (value) {
                this.forceCacheUpdate = value;
            }
        });

        let headers: Record<string, any> = {
            'Content-Type': 'application/json',
            Accept: 'application/json, text/plain, */*',
            // 'x-kcv': 'identity',
            'x-encrypted': 'false',
            // 'locationId': HttpHeaderConfigInterceptor.locationId,
        };

        if (!req.url.includes('cdn')) {
            headers = {
                ...headers,
                'x-refresh': 'true',
            };
        }

        // Add user information headers for lokos-profile and lokos-transactionAPI
        const userProfile = this.localService.get(LOCALSTORAGEKEYS.USERPROFILE);
        const userRoles = this.localService.get(LOCALSTORAGEKEYS.USERROLES);
        const currentRole =
            this.userService.getActiveRole() ||
            (userRoles && userRoles.length > 0 ? userRoles[0] : '');
        const userName =
            userProfile?.name || userProfile?.preferred_username || '';
        const tenantIdentifier =
            this.userService.getTenantId() || 'dynamic_lokos';

        if (
            (req.url.includes('v3/lokos-profile/federation') ||
                req.url.includes('v3/lokos-profile-preprod/federation') ||
                req.url.includes('fund-request/v1/proposal/fund-history')) &&
            req.method === 'GET'
        ) {
            headers = {
                ...headers,
                'Ocp-Apim-Subscription-Key': environment.reportSubscriptionKey,
                user: userName,
                role: currentRole,
                'x-tenant-identifier': tenantIdentifier,
            };
        } else if (
            req.url.includes('v3/lokos-profile') ||
            req.url.includes('v3/lokos-transaction') ||
            req.url.includes('v1/master/config') ||
            req.url.includes('/aajeevika/member') ||
            req.url.includes('v3/aajeevika') ||
            req.url.includes('master/config-preprod/v3')
        ) {
            headers = {
                ...headers,
                'Ocp-Apim-Subscription-Key': environment.reportSubscriptionKey,
                user: userName,
                role: currentRole,
                'x-tenant-identifier': tenantIdentifier,
            };
        } else if (
            (req.url.includes('profiles') && req.url.includes('all')) ||
            req.url.includes('search/lab/disbursements-history')
        ) {
            headers = {
                ...headers,
                'Ocp-Apim-Subscription-Key': environment.profileSubscriptionKey,
                user: userName,
                role: currentRole,
                'x-tenant-identifier': tenantIdentifier,
                'x-kcv': 'secure-identity',
            };
        }
        // Ensure lakhpati-didi path uses keyClockSubscriptionKey (was previously overridden by generic 'profiles' block)
        else if (req.url.includes(SERVICE_URL.REPORTS)) {
            headers = {
                ...headers,
                'x-kcv': 'secure-identity',
                'Ocp-Apim-Subscription-Key': environment.reportSubscriptionKey,
            };
        }
        // Generic profiles calls (excluding lakhpati-didi) use ocpApimSubscriptionKey
        else if (req.url.includes('profiles')) {
            headers = {
                ...headers,
                'Ocp-Apim-Subscription-Key': environment.ocpApimSubscriptionKey,
            };
        } else if (req.url.includes('keycloak')) {
            headers = {
                ...headers,
                'Ocp-Apim-Subscription-Key':
                    environment.keyClockSubscriptionKey,
            };
        } else if (req.url.includes('v1/cadre-profile/approved')) {
            headers = {
                ...headers,
                'Ocp-Apim-Subscription-Key': environment.cadreSubscriptionKey,
            };
        } else if (req.url.includes('vault') || req.url.includes('vault-uat')) {
            headers['Content-Type'] = 'image/png';
            headers['Ocp-Apim-Subscription-Key'] =
                environment.keyClockSubscriptionKey;
        } else if (req.url.includes('apis.lokos.in')) {
            headers['Ocp-Apim-Subscription-Key'] =
                environment.keyClockSubscriptionKey;
        }

        if (this.forceCacheUpdate || this.isPermanentForceCache(req.url)) {
            headers['force-update-cache'] = 'true';
        }

        const cloned = req.clone({ setHeaders: { ...headers } });
        return next.handle(cloned);
    }

    private isPermanentForceCache(url: string): boolean {
        if (
            PERMANENT_HARD_REFRESH_EXCLUDED.some((path: string) =>
                url.includes(path)
            )
        ) {
            return false;
        }
        return PERMANENT_HARD_REFRESH_REQUIRED.some((path: string) =>
            url.includes(path)
        );
    }
}
